import { render, staticRenderFns } from "./_base.vue?vue&type=template&id=127d25e7"
import script from "./_base.vue?vue&type=script&lang=js"
export * from "./_base.vue?vue&type=script&lang=js"
import style0 from "./_base.vue?vue&type=style&index=0&id=127d25e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports